import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { RoleSysAiToolsTelemetry } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { SessionsTab } from './sessions-tab'
import { PostmortemsTab } from './postmortems-tab'
import { FindingsTab } from './findings-tab'
import { useConsumers } from './use-consumers'
import { AiToolsTrail, tabCrumb } from './ai-tools-trail'

// AI tools telemetry (spec 2026-10-20 §9; contract §8): what the Caffeine
// tools and Caffeine MCP send, for EducationXR staff (SYS_AI_TOOLS_TELEMETRY
// read: the route gates it, and the page asks again, so nothing is read for
// anyone without it). Sessions, Postmortems and Findings are tabs in ?tab=;
// the consumers that have marked anything are read once here and handed to
// every tab (its filter and its mark dialog), and read again after a mark
// (a new consumer may have appeared) and when a tab's Mark dialog opens with
// none known (the first read failed or found none).
//
// Each tab keeps its grid's scroll, sort and search in the address under its
// own query keys, and a tab's link carries only ?tab=, so one tab's list
// state is never another's.
export const TABS = [
  { key: 'sessions', label: 'Sessions', Component: SessionsTab },
  { key: 'postmortems', label: 'Postmortems', Component: PostmortemsTab },
  { key: 'findings', label: 'Findings', Component: FindingsTab }
]

const AiToolsTabs = () => {
  const { search } = useLocation()
  const asked = new URLSearchParams(search).get('tab')
  const tab = TABS.find(t => t.key === asked) || TABS[0]
  const [consumers, reloadConsumers] = useConsumers()

  return (
    <FleetPage title="AI tools telemetry" purpose="What the Caffeine tools and Caffeine MCP sent from people who chose to share, and which of it has been processed." testId="ai-tools-page">
      <AiToolsTrail crumbs={[tabCrumb(tab.key)]} />
      <nav className="sw-tabs" aria-label="AI tools telemetry">
        {TABS.map(t =>
          <NavLink key={t.key} to={`/admin/ai-tools?tab=${t.key}`} isActive={() => t.key === tab.key} activeClassName="active"
            aria-current={t.key === tab.key ? 'page' : undefined}>{t.label}</NavLink>)}
      </nav>
      <tab.Component key={tab.key} consumers={consumers} onMarked={reloadConsumers} onNeedConsumers={reloadConsumers} />
    </FleetPage>
  )
}

export const AiToolsPage = () =>
  <RoleSysAiToolsTelemetry accessRead fallback={<NoAccess what="AI tools telemetry" />}>
    <AiToolsTabs />
  </RoleSysAiToolsTelemetry>
